__turbopack_context__.v({
  "body": "_0LgKva_body",
  "cell": "_0LgKva_cell",
  "col": "_0LgKva_col",
  "header": "_0LgKva_header",
  "headerColumn": "_0LgKva_headerColumn",
  "root": "_0LgKva_root",
  "topLeftHeader": "_0LgKva_topLeftHeader",
});
